import { CellContext, ColumnDefTemplate } from "@tanstack/react-table";

import { fontWeight } from "#app/theme/v1/fontWeights";
import MaterialChip from "#modules/quoteRequestLines/view/MaterialChip";
import { DimensionChip } from "#shared/view/components/DimensionChip";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import { QuoteRequestLinesListItem } from "#types/QuoteRequestLinesListItem";
import { MaterialGradeSchema } from "shared";

export const PartCell: ColumnDefTemplate<CellContext<QuoteRequestLinesListItem, string>> = ({
  row,
}) => {
  const quoteRequestLine = row.original;

  return (
    <>
      <Text fz="lg" fw={fontWeight.bold} lineClamp={1}>
        {quoteRequestLine.part.name}
      </Text>
      <Flex gap={"xxs"}>
        <DimensionChip part={quoteRequestLine.part} />
        <MaterialChip
          materialGrade={quoteRequestLine.materialGrade ?? MaterialGradeSchema.enum.OTHER}
        />
      </Flex>
    </>
  );
};
